export const trimArray = (values: string[]) => {
  if (values.length <= 0) return "-";

  if (values.length === 1) return values[0];

  return values.join(", ");
};
